// App.js
import { Routes, Route } from "react-router-dom";


import "react-quill/dist/quill.snow.css";

import Home from "./compnent/home/Home";
import Dashboard from "./compnent/Dashboard/Dashboard.jsx";
import ResetPassword from "./compnent/login/resetPassword/resetPassword.jsx";
import ForgotPassword from "./compnent/login/forgotpassword/forgotPassword.jsx";

import Login from "./compnent/login/login/login.jsx";
import SignUp from "./compnent/login/signup/signup.jsx";
import VerifyEmail from "./compnent/login/verifyEmail/verifyEmail.jsx";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { loadUserAction } from "./redux/actions/userActions.js";
import PageNotFound from "./compnent/PageNotFound/PageNotFound.jsx";
import Profile from "./compnent/profile/Profile.jsx";
import MyUpcScanSlips from "./compnent/allSlips.jsx";
import ExportExcelFile from "./compnent/ExportExcelFile.jsx";
import ProductCatalog from "./compnent/products/ProductCatalog.jsx";
import AddProduct from "./compnent/products/AddProduct.jsx";
import ImportProducts from "./compnent/products/importProducts.jsx";
import UpdateProduct from "./compnent/products/updateProdcut.jsx/UpdateProduct.jsx";
import BarcodeMapping from "./compnent/products/BarcodeMapping.jsx";



const App = () => {
  const dispatch = useDispatch();


  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(loadUserAction());
    }, 0);

    return () => clearTimeout(timer);
  }, [dispatch]);


  return (
    <>
      <ToastContainer
        position={window.innerWidth < 600 ? "bottom-center" : "bottom-right"}
        autoClose={1500}
        theme="colored"
        pauseOnHover
        hideProgressBar={false}
        closeOnClick
      />



      <Routes>
        <Route path="/" element={<Home />}>
          <Route index element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/my-upc-scan-slip" element={<MyUpcScanSlips />} />
          <Route path="/export-excel-file" element={<ExportExcelFile />} />
          <Route path="/product-catalog" element={<ProductCatalog />} />
          <Route path="/add-products" element={<AddProduct />} />
          <Route path="/add-barcode-mapping" element={<BarcodeMapping />} />
          <Route path="/import-products" element={<ImportProducts />} />
          <Route path="/update-product" element={<UpdateProduct />} />
        </Route>

        <Route path="/login/" element={<Login />} />
        <Route path="/signup/" element={<SignUp />} />
        <Route path="/verify-email/" element={<VerifyEmail />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password/" element={<ForgotPassword />} />
        <Route path="/*" element={<PageNotFound />} />

      </Routes>
    </>
  );
};

export default App;
